import React from 'react';

function Button(props){

    return (
        <button onClick={ (e) => props.handleClick(e) }>{ props.btnTxt }</button>
    )
}

export default Button
